import { render, staticRenderFns } from "./CommonArticleList.vue?vue&type=template&id=e633cdd2&"
import script from "./CommonArticleList.vue?vue&type=script&lang=js&"
export * from "./CommonArticleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports